import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { SimNaoEnum } from 'components/form'
import { isEmpty } from 'util/checks'

import { ConsultaSeguimentoPergunta13Model } from './model-consultaSeguimentoPergunta13'

export const PERGUNTA_13_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta13Model> = {
  PERGUNTA_13_HEADER: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: 'PERGUNTA_13_ANDA_SEM_APOIO',
      },
    ],
  },
  PERGUNTA_13_ANDA_SEM_APOIO: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    dependsOn: 'PERGUNTA_13_HEADER',
  },
}
